let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lhQKV")).then(() => parcelRequire('89ZRG'));